import { IconButton, Stack, Typography, useTheme } from '@mui/material';

import VectorImage from '~components/media/vectorImage';
import { Dimens } from '~themes';

interface Props {
	entityName: string;
	entityId: string;
	onRemoveClicked: () => void;
}

const SelectedEntityItem = ({ entityName, entityId, onRemoveClicked }: Props) => {
	const { palette } = useTheme();

	return (
		<Stack
			direction='row'
			justifyContent='space-between'
			alignItems='center'
			gap={Dimens.spacingMd}
			sx={{
				height: '50px',
				boxSizing: 'border-box',
				borderBottom: `${Dimens.spacing3xs} solid ${palette.borderSecondary.main}`,
			}}
		>
			<Typography
				variant='label'
				color={palette.textPrimary.main}
				noWrap
				sx={{ width: '50%', overflow: 'hidden', textOverflow: 'ellipsis' }}
			>
				{entityName}
			</Typography>
			<Typography
				variant='paragraph'
				color={palette.textTertiary.main}
				noWrap
				sx={{ width: '30%', overflow: 'hidden', textOverflow: 'ellipsis' }}
			>
				{entityId}
			</Typography>
			<IconButton
				sx={{ justifySelf: 'end', padding: Dimens.spacingXl, cursor: 'pointer' }}
				onClick={onRemoveClicked}
				aria-label={`remove ${entityName} ${entityId}`}
			>
				<VectorImage
					name='icon/cross'
					color={palette.borderError.main}
					height={Dimens.spacingXl}
					width={Dimens.spacingXl}
				/>
			</IconButton>
		</Stack>
	);
};

export default SelectedEntityItem;
